import React from 'react'
import teacher from "../imgs/teacher.png"
import { Button, Form, Row, Col } from "react-bootstrap"
import Fade from 'react-reveal/Fade';
import InputField from '../components/InputField';
import { useStateMachine } from "little-state-machine";
import { useForm } from "react-hook-form";
import updateAction from "../updateAction";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup"
import { Helmet } from 'react-helmet'
import { useNavigate } from "react-router-dom";

const Tstep1 = (props) => {
  let navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm({ mode: "all", resolver: yupResolver(schema) });
  const { state, actions } = useStateMachine({ updateAction });

  const onSubmit = data => {
    console.log(data);
    actions.updateAction(data);
    navigate("/Tstep2", { replace: true });
  };


  return (
    <>
      <Helmet>
        <title>Registration</title>
      </Helmet>
      <div className="bg"></div>
      <div className="bg bg2"></div>
      <div className="bg bg3"></div>
      {/* <div className="content"> */}

      <div className="container1">

        <div className="wrapper1">
          <ul className="steps">
            <li className="is-active">Step 2</li>
          </ul>
          <form className="form-wrapper1" onSubmit={handleSubmit(onSubmit)}>

            <fieldset className="section is-active">
              <Fade>
                <h3>Your Details</h3>

                <InputField type="email" register={register} errorinfo={errors} placeholder="example@gmail.com" label="Email Address" name="email" id="email" />
                <Row>
                  <Col>
                    <InputField register={register} errorinfo={errors} label="username" name="username" />
                  </Col>
                  <Col>
                    <InputField register={register} errorinfo={errors} type="password" label="password" name="password" />
                  </Col>
                </Row>
                <InputField register={register} errorinfo={errors} label="first name" name="firstname" />
                <InputField register={register} errorinfo={errors} label="surname" name="surname" />
                <InputField register={register} errorinfo={errors} label="City/Town" name="city" />



                <Button type="submit">next</Button>
              </Fade>
            </fieldset>

          </form>
        </div>
      </div>


      {/* </div> */}
    </>
  )
}

const schema = yup.object().shape({
  username: yup.string().trim().matches(/^[a-z\-]+$/, { message: "user name must be one word and only be common letters", excludeEmptyString: true }).required("enter a username"),
  email: yup.string().required("Enter a valid email address"),
  password: yup.string().trim().min(8, "The password must have at least 8 characters, at least 1 digit(s), at least 1 lower case letter(s), at least 1 upper case letter(s), at least 1 non-alphanumeric character(s) such as as *, -, or #").matches(/^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/, "The password must have at least 8 characters, at least 1 digit(s), at least 1 lower case letter(s), at least 1 upper case letter(s), at least 1 non-alphanumeric character(s) such as as *, -, or #").required("The password must have at least 8 characters, at least 1 digit(s), at least 1 lower case letter(s), at least 1 upper case letter(s), at least 1 non-alphanumeric character(s) such as as *, -, or #"),
  firstname: yup.string().required("enter your firstname"),
  surname: yup.string().required("enter your surname"),
  city: yup.string().required("enter your city/town"),

})


export default Tstep1
